import js from "./resimler/js-logo.png";
import react from "./resimler/react-logo.png";
import redux from "./resimler/redux-logo.png";
import node from "./resimler/node-logo.png";
import vscode from "./resimler/vscode-logo.png";
import figma from "./resimler/figma-logo.png";

export const skillsData1 = [
  { id: 1, isim: "JAVASCRIPT", image: js },
  { id: 2, isim: "REACT", image: react },
  { id: 3, isim: "REDUX", image: redux },
];

export const skillsData2 = [
  { id: 4, isim: "NODE", image: node },
  { id: 5, isim: "VS-CODE", image: vscode },
  { id: 6, isim: "FIGMA", image: figma },
];

export const skillsData3 = [
  {
    id: 1,
    aciklama:
      "JavaScript, web tarayıcılarında yaygın olarak kullanılan dinamik bir programlama dilidir. JS ile yazılan istemci taraflı scriptler, tarayıcı-kullanıcı arası etkileşimler ve özellikle asenkron etkileşim, içeriklerin gösterimi, değiştirilmesi gibi web sitelerinin davranışlarını yönetir. İstemci tarafının yanısıra, NodeJS gibi ortamlar sayesinde sunucu tarafında da oldukça yaygın olarak kullanılır.",
  },
  {
    id: 2,
    aciklama:
      "ReactJS, dünya çapında yaklaşık 10,2 milyon web sitesi tarafından kullanılan, geliştiriciler için popüler bir front end web geliştirme aracıdır. ",
  },
  {
    id: 3,
    aciklama:
      "Redux, uygulama durumunu yönetmek ve merkezileştirmek için açık kaynaklı bir JavaScript kitaplığıdır.",
  },
  {
    id: 4,
    aciklama:
      "Node.js, açık kaynaklı, genelde sunucu tarafında çalışan ve ağ bağlantılı uygulamalar için geliştirilmiş bir çalıştırma ortamıdır.",
  },
  {
    id: 5,
    aciklama:
      "Visual Studio Code Microsoft tarafından Windows, Linux ve MacOS için geliştirilen bir kaynak kodu düzenleyicisidir. Hata ayıklama, gömülü Git kontrolü, sözdizimi vurgulama, akıllı kod tamamlama, snippet'ler ve kod yeniden yapılandırma desteği içerir.",
  },
  {
    id: 6,
    aciklama:
      "Figma, macOS ve Windows için masaüstü uygulamaları tarafından etkinleştirilen ek çevrimdışı özelliklerle, web tabanlı bir vektör grafik düzenleyici ve prototip oluşturma aracıdır. ",
  },
];
